import FormattedMessage from 'I18n/components/FormattedMessage';
import LoadingOverlayWithMessage from '../LoadingOverlayWithMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ChangeTemplateLoading = () => {
  return /*#__PURE__*/_jsx(LoadingOverlayWithMessage, {
    "data-test-id": "change-template-loading",
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.chooseTemplate.changeTemplateLoadingLabel"
    })
  });
};
export default ChangeTemplateLoading;